import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.982 18.725C17.2833 17.7999 16.3792 17.0496 15.3412 16.5334C14.3031 16.0171 13.1594 15.7489 12 15.75C10.8406 15.7489 9.69688 16.0171 8.65882 16.5334C7.62075 17.0496 6.71674 17.7999 6.018 18.725M17.982 18.725C19.3455 17.5122 20.3071 15.9135 20.7412 14.1411C21.1752 12.3686 21.0603 10.5061 20.4115 8.80047C19.7627 7.09486 18.6107 5.62677 17.1084 4.59089C15.6061 3.55501 13.8243 3.00029 11.9995 3.00029C10.1747 3.00029 8.39293 3.55501 6.8906 4.59089C5.38827 5.62677 4.23633 7.09486 3.58753 8.80047C2.93874 10.5061 2.82375 12.3686 3.25782 14.1411C3.69188 15.9135 4.6545 17.5122 6.018 18.725M17.982 18.725C16.336 20.1932 14.2056 21.0031 12 21C9.79403 21.0034 7.66423 20.1934 6.018 18.725M15 9.75C15 10.5456 14.6839 11.3087 14.1213 11.8713C13.5587 12.4339 12.7956 12.75 12 12.75C11.2043 12.75 10.4413 12.4339 9.87868 11.8713C9.31607 11.3087 9 10.5456 9 9.75C9 8.95435 9.31607 8.19128 9.87868 7.62867C10.4413 7.06607 11.2043 6.74999 12 6.74999C12.7956 6.74999 13.5587 7.06607 14.1213 7.62867C14.6839 8.19128 15 8.95435 15 9.75Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }